/*
  Zainetto nel carrello laterale: la miniatura della riga diventa lo zaino con le
  scelte del cliente (stesse misure dell'anteprima della pagina prodotto).
  Le righe arrivano da snippets/rlz-zn-cart-data.liquid. Se qualcosa non carica,
  resta la foto della variante: il carrello funziona lo stesso.
  Il carrello viene ridisegnato dal tema a ogni modifica: lo osserva un MutationObserver.
*/
(function () {
  'use strict';
  if (window.__rlzZnCart) return;
  window.__rlzZnCart = true;

  var L = { size: 4096, nameCx: 2047, nameCy: 1240, nameCap: 433, nameMaxW: 1701, nameMaxH: 864,
            animalCx: 2020, animalCy: 2878, animalLong: 900, animalBase: 3328, crop: [520, 320, 3580, 3380] };
  var FAMILY = 'RlzZnCart';
  var fontPromise = null;

  function loadFont(url) {
    if (fontPromise) return fontPromise;
    if (!window.FontFace || !document.fonts) { fontPromise = Promise.resolve(); return fontPromise; }
    fontPromise = new FontFace(FAMILY, 'url(' + url + ')').load()
      .then(function (f) { document.fonts.add(f); })
      .catch(function () {});
    return fontPromise;
  }

  var imgCache = {};
  function loadImg(src) {
    if (imgCache[src]) return imgCache[src];
    imgCache[src] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = src;
    });
    return imgCache[src];
  }

  function draw(el) {
    el.setAttribute('data-rlz-zn-done', '1');
    var d = el.dataset;
    Promise.all([loadImg(d.base), loadImg(d.animal), loadFont(d.font)]).then(function (r) {
      var base = r[0], animal = r[1];
      var c = document.createElement('canvas');
      c.width = 300; c.height = 300;
      var ctx = c.getContext('2d');
      var cw = L.crop[2] - L.crop[0];
      var s = c.width / cw;
      var ox = -L.crop[0] * s, oy = -L.crop[1] * s;
      ctx.drawImage(base, ox, oy, L.size * s, L.size * s);
      var cm = parseFloat(d.cm) || 10;
      var k = (L.animalLong * (cm / 10) * s) / Math.max(animal.naturalWidth, animal.naturalHeight);
      var aw = animal.naturalWidth * k, ah = animal.naturalHeight * k;
      ctx.drawImage(animal, ox + L.animalCx * s - aw / 2, oy + L.animalBase * s - ah, aw, ah);
      var text = (d.name || '').replace(/\s+/g, ' ').trim();
      if (text) {
        var size = 100;
        ctx.font = size + 'px ' + FAMILY;
        var capH = ctx.measureText('H').actualBoundingBoxAscent || 70;
        size = size * (L.nameCap * s) / capH;
        for (var i = 0; i < 3; i++) {
          ctx.font = size + 'px ' + FAMILY;
          var m0 = ctx.measureText(text);
          var w = (m0.actualBoundingBoxLeft || 0) + (m0.actualBoundingBoxRight || m0.width);
          var h = (m0.actualBoundingBoxAscent || 0) + (m0.actualBoundingBoxDescent || 0);
          var f = Math.min(1, (L.nameMaxW * s) / Math.max(w, 1), (L.nameMaxH * s) / Math.max(h, 1));
          if (f > 0.995) break;
          size *= f;
        }
        ctx.font = size + 'px ' + FAMILY;
        var m = ctx.measureText(text);
        var left = m.actualBoundingBoxLeft || 0, right = m.actualBoundingBoxRight || m.width;
        var asc = m.actualBoundingBoxAscent || 0, desc = m.actualBoundingBoxDescent || 0;
        var x = ox + L.nameCx * s - (right - left) / 2;
        var y = oy + L.nameCy * s - (desc - asc) / 2;
        ctx.fillStyle = d.color || '#fff';
        if (d.version === 'Ricamato') {
          ctx.shadowColor = 'rgba(0,0,0,0.35)';
          ctx.shadowBlur = 1.5;
          ctx.shadowOffsetX = 0.6;
          ctx.shadowOffsetY = 0.8;
        }
        ctx.fillText(text, x, y);
      }
      try {
        el.src = c.toDataURL('image/jpeg', 0.9);
        el.removeAttribute('srcset');
      } catch (e) { /* immagini non leggibili: resta la foto della variante */ }
    }).catch(function () { /* resta la foto della variante */ });
  }

  function scan() {
    document.querySelectorAll('img[data-rlz-zn-cart]:not([data-rlz-zn-done])').forEach(draw);
  }

  function start() {
    scan();
    if ('MutationObserver' in window) new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
